import React from "react";
import T from "prop-types";
import api from "APP_ROOT/api";
import {
  translateProps,
  toggleSwitch,
  renderIf
} from "MODULES/shared/decorators";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import { DropDownItem } from "MODULES/shared/components/DropDown";
import { Icon, ConfirmAction } from "MODULES/shared/components";
import withCurrentUser, {
  WithCurrentUser
} from "MODULES/session/decorators/withCurrentUser";
import { ADMIN, ACCOUNTING } from "MODULES/users/constants";

export function ExchangeReversal({ reverse, reversingExchange, open, close }) {
  return (
    <DropDownItem onClick={open}>
      <Icon name="undo" fixed />
      <span className="with-padding">Convert To Outright SO</span>
      <ConfirmAction onConfirm={reverse} close={close} open={reversingExchange}>
        <strong>Heads up! </strong>
        <span className="with-padding">
          Are you sure you want to reverse this exchange?
        </span>
      </ConfirmAction>
    </DropDownItem>
  );
}

ExchangeReversal.propTypes = {
  reverse: T.func.isRequired,
  reversingExchange: T.bool.isRequired,
  open: T.func.isRequired,
  close: T.func.isRequired,
  ...WithCurrentUser
};

const withExchange = translateProps(
  ({
    lineItem: { id: itemId },
    close,
    refresh,
    salesOrder,
    expireLineItems
  }) => ({
    reverse: () =>
      api.salesOrders.lineItems.exchangeReversal(itemId).then(() => {
        refresh(salesOrder.get("id")).then(() => {
          expireLineItems();
          close();
        });
      })
  })
);

const meetsExchangeReversalCriteria = renderIf(
  ({
    lineItem: {
      cancelled,
      shipped,
      exchange_sale: exchange,
      created_by_id: createdById
    },
    currentUser: { role, id: currentUserId }
  }) =>
    ([ADMIN, ACCOUNTING].includes(role) || createdById === currentUserId) &&
    !cancelled &&
    exchange &&
    !shipped
);

export default withSalesOrder(
  toggleSwitch("reversingExchange")(
    withCurrentUser(
      withExchange(meetsExchangeReversalCriteria(ExchangeReversal))
    )
  )
);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/ExchangeReversal.jsx